// src/components/Sidebar.js
// import React, { useState } from 'react';
import { Link } from "react-router-dom";
import "../styles/Sidebar.css";
import logo from "../assets/logoglobe.jpg";

const Sidebar = ({ closeMenu }) => {
  return (
    <div className="sidebars">
      <div onClick={closeMenu} className="sidebars-header">
        <div className="logo-sections">
          <Link to="/" className="logo-link">
            <img src={logo} alt="Flenny Scent Logo" className="logo-image" />
            <div className="logo-text">
              <span className="brand-name">Global Tongue</span>
              <span className="slogan">Breaking Language Barriers</span>
            </div>
          </Link>
        </div>
        <button
          onClick={closeMenu}
          className="close-btn"
          aria-label="Close sidebar"
        >
          ✕
        </button>
      </div>

      <ul className="sidebars-links">
        <li onClick={closeMenu}>
          <Link to="/">
            Home <span className="arrow">→</span>
          </Link>
        </li>
        <li onClick={closeMenu}>
          <Link to="/About">
            About <span className="arrow">→</span>
          </Link>
        </li>
        <li onClick={closeMenu}>
          <Link to="/ServiceList">
            Services <span className="arrow">→</span>
          </Link>
        </li>
        <li onClick={closeMenu}>
          <Link to="/Team">
            Team <span className="arrow">→</span>
          </Link>
        </li>
        <li onClick={closeMenu}>
          <Link to="/ContactForm">
            Contact <span className="arrow">→</span>
          </Link>
        </li>
        <li onClick={closeMenu}>
          <a href="mailto:globaltongue.official@gmail.com">Help Centre</a>
        </li>
      </ul>
    </div>
  );
};

export default Sidebar;
